// extracted by mini-css-extract-plugin
export default {"not-available-blank":"index__not-available-blank--pu5iU","not-available-text":"index__not-available-text--Q3z62"};